import { Box } from "@mui/material";

import CreateSKU from "./components/CreateSKU";
import SKUsTable from "./components/SKUsTable";

const SKUsPage = (): JSX.Element => {
  return (
    <Box>
      <Box padding="0.75em 0">
        <CreateSKU />
      </Box>
      <SKUsTable />
    </Box>
  );
};

export default SKUsPage;
